'use client';
import { Conditional } from '@cat-ecom/pcc-components';
import ProductCardPrice from '../product-comparison-card/product-card-price';

interface ProductCardPriceDetailsProps {
  currency: string;
  totalPrice: string | number;
  discountAmount: string | number;
  unitPrice: string | number;
  shouldDisplayPrice: boolean;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
  className?: string;
}

const ProductCardPriceDetails = ({
  currency,
  totalPrice,
  discountAmount,
  unitPrice,
  shouldDisplayPrice,
  isRTL,
  currencyLdFeatureFlag,
  className
}: ProductCardPriceDetailsProps) => {
  return (
    <Conditional
      test={shouldDisplayPrice}
      fallback={<div className={`${className} mt-auto`} />}
    >
      <div className={`${className} mt-auto`}>
        <ProductCardPrice
          currency={currency}
          totalPrice={totalPrice}
          discountAmount={discountAmount}
          unitPrice={unitPrice}
          isRTL={isRTL}
          currencyLdFeatureFlag={currencyLdFeatureFlag}
        />
      </div>
    </Conditional>
  );
};

export default ProductCardPriceDetails;
